import React, { useEffect, useState } from 'react'
import { Offcanvas } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'

// Redux slices
import { setPageTitle } from '../redux/slice/pageTitleSlice'

// Utilities and Libraries
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'

// Components
import NotFound from '../NotFound/NotFound'
import ManageAssignRolesTabbing from './AssignRoles/ManageAssignRolesTabbing'
import ChargesPaidByTabbing from './ChargesPaidBy/ChargesPaidByTabbing'
import CommissionChargesTabbing from './CommissionCharges/CommissionChargesTabbing'
import ExtraChargesTabbing from './ExtraCharges/ExtraChargesTabbing'
import ManageAdminTabbing from './ManageAdmin/ManageAdminTabbing'
import CSCTabbing from './ManageCSC/CSCTabbing'
import ConfigTabbing from './ManageConfig/ConfigTabbing'
import DeliveryTabbing from './ManageDelivery/DeliveryTabbing'
import ManageHomePage from './ManageHomePage/ManageHomePage'
import HSNCode from './ManageHsnAndTaxRate/HSNCodeTabbing'
import ManageIssueAndRejectionTabbing from './ManageIssueAndRejection/ManageIssueAndRejectionTabbing'
import ManageLayout from './ManageLayout/ManageLayout'
import MainMenu from './ManageMenu/MainMenu'
import ManageReturnTabbing from './ManageReturn/ManageReturnTabbing'
import RoleTabbing from './ManageRole/RoleTabbing'
import StaticPageList from './ManageStaticPage/StaticPageList'
import ManageTax from './ManageTax/ManageTax'
import WeightSlabTabbing from './WeightSlab/WeightSlabTabbing'

const Setting = () => {
  const [activeTogglesetting, setActiveTogglesetting] = useState('finance')
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const { pageAccess, userInfo } = useSelector((state) => state.user)
  const [showOffcanvas, setShowOffcanvas] = useState(false)
  const [offcanvasTitle, setOffcanvasTitle] = useState('')
  const [offcanvasContent, setOffcanvasContent] = useState('')

  const handleLinkClick = (title, content) => {
    setOffcanvasTitle(title)
    setOffcanvasContent(content)
    setShowOffcanvas(true)
  }

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false)
    dispatch(setPageTitle('Settings'))
  }

  const OffcanvasComponent = ({ show, onHide, title, children }) => {
    return (
      <Offcanvas
        show={show}
        onHide={onHide}
        placement='end'
        className='pv-offcanvas'
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    )
  }

  const Linkrender = () => {
    return (
      <OffcanvasComponent
        show={showOffcanvas}
        onHide={handleCloseOffcanvas}
        title={offcanvasTitle}
      >
        {offcanvasContent}
      </OffcanvasComponent>
    )
  }

  useEffect(() => {
    dispatch(setPageTitle('Settings'))
  }, [])

  useEffect(() => {
    if (tab === 'manage-commission') {
      handleLinkClick('Commission Management', <CommissionChargesTabbing />)
    }
  }, [])

  return checkPageAccess(pageAccess, allPages?.settings, allCrudNames?.read) ? (
    <>
      <Linkrender />
      <div className='d-flex gap-3 align-items-start'>
        <div className='card col-md-2'>
          <div className='card-body p-0'>
            <div className='nav-tabs-vertical flex-column nav nav-tabs p-2 gap-2'>
              <Link
                onClick={() => setActiveTogglesetting('finance')}
                data-toggle='tab'
                className={`d-flex flex-column gap-2 align-items-center nav-link ${
                  activeTogglesetting === 'finance' ? 'active show' : ''
                }`}
              >
                <i className='m-icon m-icon--finance'></i>
                <span className='text-capitalize fs-6 bold lh-1'>Finance</span>
              </Link>
              <Link
                onClick={() => setActiveTogglesetting('appearance')}
                data-toggle='tab'
                className={`d-flex flex-column gap-2 align-items-center nav-link ${
                  activeTogglesetting === 'appearance' ? 'active show' : ''
                }`}
              >
                <i className='m-icon m-icon--appearance'></i>
                <span className='text-capitalize fs-6 bold lh-1'>
                  appearance
                </span>
              </Link>
              <Link
                onClick={() => setActiveTogglesetting('shipping')}
                data-toggle='tab'
                className={`d-flex flex-column gap-2 align-items-center nav-link ${
                  activeTogglesetting === 'shipping' ? 'active show' : ''
                }`}
              >
                <i className='m-icon m-icon--shipping'></i>
                <span className='text-capitalize fs-6 bold lh-1'>Shipping</span>
              </Link>
              <Link
                onClick={() => setActiveTogglesetting('management')}
                data-toggle='tab'
                className={`d-flex flex-column gap-2 align-items-center nav-link ${
                  activeTogglesetting === 'management' ? 'active show' : ''
                }`}
              >
                <i className='m-icon m-icon--management'></i>
                <span className='text-capitalize fs-6 bold lh-1'>
                  Management
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className='tab-content col flex-fill pv-setting-tab'>
          <div
            id='finance'
            className={`tab-pane fade card ${
              activeTogglesetting === 'finance' ? 'active show' : ''
            }`}
          >
            {activeTogglesetting === 'finance' && (
              <>
                <div className='d-grid settings_cards_grid'>
                  {checkPageAccess(
                    pageAccess,
                    [
                      allPages?.hsnCode,
                      allPages?.assignTaxRateToHSN,
                      allPages?.manageTax,
                      allPages?.manageCommission,
                      allPages?.extraCharges
                    ],
                    allCrudNames?.read
                  ) && (
                    <>
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageCommission,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() => {
                            handleLinkClick(
                              'Commission Management',
                              <CommissionChargesTabbing />
                            )
                          }}
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--finance'></i>
                                <p className='fs-5 mb-0'>
                                  Commission Management
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageCommission,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() => {
                            handleLinkClick(
                              'Extra Charges Setup',
                              <ExtraChargesTabbing />
                            )
                          }}
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageExtraCharge'></i>
                                <p className='fs-5 mb-0'>Extra Charges Setup</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        [allPages?.hsnCode, allPages?.assignTaxRateToHSN],
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() => {
                            handleLinkClick('HSN Code Management', <HSNCode />)
                          }}
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--hsncode'></i>
                                <p className='fs-5 mb-0'>HSN Code Management</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageTax,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick('Tax Settings ', <ManageTax />)
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageTax'></i>
                                <p className='fs-5 mb-0'>Tax Settings</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div
            id='appearance'
            className={`tab-pane fade card ${
              activeTogglesetting === 'appearance' ? 'active show' : ''
            }`}
          >
            {activeTogglesetting === 'appearance' && (
              <>
                <div className='d-grid settings_cards_grid'>
                  {checkPageAccess(
                    pageAccess,
                    [
                      allPages?.manageLayout,
                      allPages?.manageMenu,
                      allPages?.flashSaleCollectionMapping,
                      allPages?.addFlashSaleCollection,
                      allPages?.createProductCollection,
                      allPages?.collectionMappingList,
                      allPages?.manageStaticPage,
                      allPages?.homePage,
                      allPages?.lendingPage
                    ],
                    allCrudNames?.read
                  ) && (
                    <>
                      {(userInfo?.userName === 'harsh@hashtechy.com' ||
                        userInfo?.userName === 'admin.k@hashtechy.com') && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Layout Customization',
                              <ManageLayout />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageLayout'></i>
                                <p className='fs-5 mb-0'>
                                  Layout Customization
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageMenu,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick('Menu Configuration', <MainMenu />)
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageMenu'></i>
                                <p className='fs-5 mb-0'>Menu Configuration</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* {checkPageAccess(
                        pageAccess,
                        [
                          allPages?.flashSaleCollectionMapping,
                          allPages?.addFlashSaleCollection
                        ],
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Flash Sale Collection Setup',
                              <FlashSaleTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--flashSaleCollection'></i>
                                <p className='fs-5 mb-0'>
                                  Flash Sale Collection Setup
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        [
                          allPages?.createProductCollection,
                          allPages?.collectionMappingList
                        ],
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Collection Management',
                              <CollectionTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageCollection'></i>
                                <p className='fs-5 mb-0'>
                                  Collection Management
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageStaticPage,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Static Page Settings',
                              <StaticPageList />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageStaticPage'></i>
                                <p className='fs-5 mb-0'>
                                  Static Page Settings
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.homePage,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Homepage Customization',
                              <ManageHomePage />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageCollection'></i>
                                <p className='fs-5 mb-0'>
                                  Homepage Customization
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* {checkPageAccess(
                        pageAccess,
                        allPages?.lendingPage,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Landing Page Design',
                              <ManageLendingPage />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageStaticPage'></i>
                                <p className='fs-5 mb-0'>Landing Page Design</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div
            id='shipping'
            className={`tab-pane fade card ${
              activeTogglesetting === 'shipping' ? 'active show' : ''
            }`}
          >
            {activeTogglesetting === 'shipping' && (
              <>
                <div className='d-grid settings_cards_grid'>
                  {checkPageAccess(
                    pageAccess,
                    [
                      allPages?.manageCountry,
                      allPages?.manageState,
                      allPages?.manageCity,
                      allPages?.manageDelivery
                    ],
                    allCrudNames?.read
                  ) && (
                    <>
                      {checkPageAccess(
                        pageAccess,
                        [
                          allPages?.manageCountry,
                          allPages?.manageState,
                          allPages?.manageCity
                        ],
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Country, State, and City Management',
                              <CSCTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageCSC'></i>
                                <p className='fs-5 mb-0'>
                                  Country, State, and City Management
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageDelivery,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Delivery Options',
                              <DeliveryTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageDelivery'></i>
                                <p className='fs-5 mb-0'>Delivery Options</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div
            id='management'
            className={`tab-pane fade card ${
              activeTogglesetting === 'management' ? 'active show' : ''
            }`}
          >
            {activeTogglesetting === 'management' && (
              <>
                <div className='d-grid settings_cards_grid'>
                  {checkPageAccess(
                    pageAccess,
                    [
                      allPages?.weightSlab,
                      allPages?.manageAdmin,
                      allPages?.manageIssueandRejection,
                      allPages?.manageChargesPaidBy,
                      allPages?.manageRoles,
                      allPages?.manageUserRole,
                      allPages?.manageConfig,
                      allPages?.assignReturnToCategory,
                      allPages?.manageReturn
                    ],
                    allCrudNames?.read
                  ) && (
                    <>
                      {checkPageAccess(
                        pageAccess,
                        allPages?.weightSlab,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Weight Slab Settings',
                              <WeightSlabTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--weightslab'></i>
                                <p className='fs-5 mb-0'>
                                  Weight Slab Settings
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageAdmin,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Admin Configuration',
                              <ManageAdminTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageAdmin'></i>
                                <p className='fs-5 mb-0'>Admin Configuration</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageIssueandRejection,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Issue and Rejection Handling',
                              <ManageIssueAndRejectionTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--issueandrejection'></i>
                                <p className='fs-5 mb-0'>
                                  Issue and Rejection Handling
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageChargesPaidBy,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Charges Paid By Management',
                              <ChargesPaidByTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--managechargespaid'></i>
                                <p className='fs-5 mb-0'>
                                  Charges Paid By Management
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {userInfo?.userType?.toLowerCase() === 'super admin' && (
                        <div
                          onClick={() =>
                            handleLinkClick('Role Management', <RoleTabbing />)
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageRoles'></i>
                                <p className='fs-5 mb-0'>Role Management</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {userInfo?.userType?.toLowerCase() === 'super admin' && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Page Role Assignment',
                              <ManageAssignRolesTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--assignpagerole'></i>
                                <p className='fs-5 mb-0'>
                                  Page Role Assignment
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageConfig,
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'System Configuration',
                              <ConfigTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--manageconfig'></i>
                                <p className='fs-5 mb-0'>
                                  System Configuration
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        [
                          allPages?.assignReturnToCategory,
                          allPages?.manageReturn
                        ],
                        allCrudNames?.read
                      ) && (
                        <div
                          onClick={() =>
                            handleLinkClick(
                              'Return Management',
                              <ManageReturnTabbing />
                            )
                          }
                        >
                          <div className='card mb-3'>
                            <div className='card-body'>
                              <div className='pv-setting-card-des'>
                                <i className='m-icon m-icon--managereturn'></i>
                                <p className='fs-5 mb-0'>Return Management</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default Setting
